import { fetchAuthSession, AuthError as AmplifyAuthError } from "aws-amplify/auth"
import { LoggerService } from "@/modules/common/logger/loggerService"
import { isTokenValid } from "@/modules/auth/utils/isTokenValid"
import { AuthError } from "@/modules/auth/authErrorTypes"
import { LoggerType } from "@/modules/utils/loggerUtils"

export const getSessionInformations = async (forceRefresh = false) => {
  try {
    const session = await fetchAuthSession({ forceRefresh })
    console.log(LoggerType.Auth + `[Cognito] fetchAuthSession succeeded ✅ (forceRefresh: ${String(forceRefresh)})`)
    return {
      idToken: session.tokens?.idToken,
      expirationNumber: session.tokens?.idToken?.payload.exp,
      isIdTokenValid: isTokenValid(session.tokens?.idToken?.payload.exp),
    }
  } catch (e) {
    // UserLambdaValidationException means Cognito's Pre-Token Generation Lambda failed — either a
    // backend error (502, 503) or a Lambda timeout (3s hard limit). Transient infra noise — skip Sentry.
    if (e instanceof AmplifyAuthError && e.name === AuthError.UserLambdaValidationException) {
      console.warn(
        LoggerType.Auth +
          `[Cognito] fetchAuthSession failed ❌ (forceRefresh: ${String(forceRefresh)}) — UserLambdaValidationException (skipping Sentry)`,
      )
      throw e
    }
    // NotAuthorizedException means the refresh token is expired or revoked — expected when a session
    // ages out. getValidToken catches this and returns undefined so the 401 flow handles logout.
    // Reporting to Sentry here would be noise (WEB-2BJ).
    if (e instanceof AmplifyAuthError && e.name === AuthError.NotAuthorizedException) {
      console.warn(
        LoggerType.Auth +
          `[Cognito] fetchAuthSession failed ❌ (forceRefresh: ${String(forceRefresh)}) — NotAuthorizedException / session expired (skipping Sentry)`,
      )
      throw e
    }
    // NetworkError is a transient connectivity failure (offline, flaky network). Sentry noise (WEB-1TX).
    if (e instanceof AmplifyAuthError && e.name === AuthError.NetworkError) {
      console.warn(
        LoggerType.Auth +
          `[Cognito] fetchAuthSession failed ❌ (forceRefresh: ${String(forceRefresh)}) — NetworkError (skipping Sentry)`,
      )
      throw e
    }
    LoggerService.captureException(
      LoggerType.Auth + `[Cognito] fetchAuthSession failed ❌ (forceRefresh: ${String(forceRefresh)})`,
      e,
    )
    throw e
  }
}
